import { FilterSetting } from "@/types/filter";

export const DEFAULT_PAGE_SIZE = 20;
export const DISTANCE_TO_PAGINATE = 10;

export const DEFAULT_FILTER: FilterSetting = {
  multiLevelSelectedCategories: undefined,
  page: 1,
  page_size: DEFAULT_PAGE_SIZE,
  search: "",
  selectedCategories: [],
  selectedAttributes: [],
  selectedBrands: [],
  selectedSortBy: [],
  next_page: 2,
  previous_page: null,
  total_items: null,
  selectedMerchandisings: [],
  favorite: false,
  selectedTags: [],
  closets: undefined,
  by_main_closet: undefined
};

// Sort Name dict
export const sortModes = {
  "-name": "Z to A",
  name: "A to Z",
  "-sort_date": "Newest",
  sort_date: "Oldest",
  category_priority: "Category",
  color_name: "Color"
};
